// extracted by mini-css-extract-plugin
export default {"pager":"app-duplicatePrevention-record-RecordPager-RecordPager-module__weY7RA8xfA9xh32jtWk9"};